import {
  Report,
  ReportType,
} from '@/shared/api/protocol-ts/model/dto_report_pb';

export const getCBCTPreviewReport = (reports: Report[]): Report | undefined => {
  const sortedReports = [...reports].sort((a, b) => {
    const aTime = a.Created?.At?.toDate().getTime() ?? 0;
    const bTime = b.Created?.At?.toDate().getTime() ?? 0;
    return bTime - aTime;
  });

  const cbctGPReport = sortedReports.find(
    (report) => report.Type === ReportType.ReportType_CBCT_GP,
  );

  if (cbctGPReport) {
    return cbctGPReport;
  }

  return sortedReports.find(
    (report) => report.Type !== ReportType.ReportType_StudioImplant,
  );
};
